// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2g33c","content":"styles_content__ESmyF","checkbox":"styles_checkbox__3tIuB","checkboxLabel":"styles_checkboxLabel__2HK2I"};